import { render, staticRenderFns } from "./Home.data-manager-vertical.vue?vue&type=template&id=f535b890&scoped=true&"
import script from "./Home.data-manager-vertical.vue?vue&type=script&lang=js&"
export * from "./Home.data-manager-vertical.vue?vue&type=script&lang=js&"
import style0 from "./Home.data-manager-vertical.vue?vue&type=style&index=0&id=f535b890&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535b890",
  null
  
)

export default component.exports